import { UseFormReturn } from 'react-hook-form';
import { IExchangeRateForm } from '../../../pages/TravelRequest/constants/travelreq.interface';
import { DateInput, NumberInput, SelectInput } from '../..';
import { IAntdDropdown } from '../../../pages/Requisitions/constants/requisition.interface';
import { ExchangeRateMappingFormKeys } from '../../../pages/TravelRequest/constants/travelreq.enum';

export default function ExchangeRateForm({
  form,
  dropdownOptions,
}: {
  form: UseFormReturn<IExchangeRateForm>;
  dropdownOptions: {
    currency: IAntdDropdown[];
  };
}) {
  const { control, formState } = form;
  

  return (
    <div>
      <form className="flex flex-col gap-4">
        <div className="grid grid-cols-1 gap-4">
          <SelectInput
            name={ExchangeRateMappingFormKeys.SOURCE_CURRENCY}
            control={control}
            label="Source Currency *"
            formState={formState}
            config={{
              showSearch: true,
              placeholder: 'Select source currency',
              options: dropdownOptions?.currency,
              optionFilterProp: 'label',
              optionLabelProp: 'label',
            }}
            rules={{
              required: '* This field is required',
            }}
          />
          <SelectInput
            name={ExchangeRateMappingFormKeys.TARGET_CURRENCY}
            control={control}
            label="Target Currency *"
            formState={formState}
            config={{
              showSearch: true,
              placeholder: 'Select target currency',
              options: dropdownOptions?.currency,
              optionFilterProp: 'label',
              optionLabelProp: 'label',
            }}
            rules={{
              required: '* This field is required',
            }}
          />
          <DateInput
                      name={ExchangeRateMappingFormKeys.RATE_DATE}
                      control={control}
                      label={'Rate Date'}
                      formState={formState}
                    />
          
                    <NumberInput
                      name={ExchangeRateMappingFormKeys.RATE_PER_UNIT_IN_TARGET}
                      control={control}
                      formState={formState}
                      label="Rate Per Unit In Target Currency *"
                      config={{
                        type: 'number',
                        placeholder: 'Enter rate per unit in target currency',
                        precision: 2,
                        min: 0,
                        controls: false,
                      }}
                      addOnClass="w-full"
                    />
          
        </div>
      </form>
    </div>
  );
}
